import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import { useSearchParams } from 'react-router-dom';
import PurchaseOrderSearchGrid from '../../../features/distributor/order-search-grid/components/PurchaseOrderSearchGrid';

export default function PurchaseOrderSearchPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Order Search')
	}, [pageTitle]);

	let [searchParams] = useSearchParams();

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<PurchaseOrderSearchGrid
					searchField={searchParams.get("searchField")!}
					searchText={searchParams.get("searchText")!}
				/>
			</div>
		</React.Fragment>
	)
} 
